// Parameters and Glossary shortcuts for the Shortcuts dialog: list search and arrow-key movement in the glossary term list.
import type { ShortcutDef } from "@/app/shortcuts";

export const VOCABULARY_SHORTCUTS: readonly ShortcutDef[] = [
  { id: "vocabulary-search", keys: [["/"]], description: "Search the parameter or glossary list" },
  { id: "vocabulary-move", keys: [["↓"], ["↑"]], description: "Next or previous glossary term" },
  { id: "vocabulary-escape", keys: [["Esc"]], description: "Clear the search or close a term card" },
];
